import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-b from-sky-50 to-white py-20">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Text content */}
          <div className="w-full md:w-1/2 text-center md:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-gray-900">
              We help you streamline the process of reaching your <span className="text-sky-600">dream body</span>
            </h1>

            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Using a science-based approach to help you reach your fitness goals
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center md:justify-start">
              <a 
                href="#packages" 
                className="w-full sm:w-auto bg-sky-600 text-white px-8 py-4 rounded-xl text-xl font-semibold hover:bg-sky-700 transition flex items-center justify-center gap-2"
                onClick={(e) => {
                  e.preventDefault();
                  const packagesSection = document.getElementById('packages');
                  if (packagesSection) {
                    packagesSection.scrollIntoView({ behavior: 'smooth' });
                    // Set the active tab to 'premium' to show the Platinum option
                    const premiumTab = document.querySelector('button[onclick*="setActiveTab(\'premium\')"]');
                    if (premiumTab) {
                      premiumTab.click();
                    }
                  }
                }}
              >
                Get Started with a Free Trial
                <ArrowRight size={20} />
              </a>
            </div>
            
            <div className="mt-12 sm:mt-16">
  <div className="overflow-x-auto scrollbar-hide pb-4">
    <div className="flex sm:grid sm:grid-cols-3 gap-4 sm:gap-6 px-4 sm:px-0 max-w-5xl mx-auto">
      <div className="text-center p-4 sm:p-6 lg:p-8 bg-gradient-to-br from-sky-50 to-blue-50 rounded-2xl border border-sky-100 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex-shrink-0 w-64 sm:w-auto">
        <div className="text-4xl sm:text-5xl mb-2">🤝</div>
        <div className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-black text-sky-600 mb-2 sm:mb-3 lg:mb-4">500+</div>
        <div className="text-xs sm:text-sm lg:text-base font-bold text-gray-800 uppercase tracking-wide leading-tight">People Helped</div>
      </div>
      <div className="text-center p-4 sm:p-6 lg:p-8 bg-gradient-to-br from-sky-50 to-blue-50 rounded-2xl border border-sky-100 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex-shrink-0 w-64 sm:w-auto">
        <div className="text-4xl sm:text-5xl mb-2">⚡</div>
        <div className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-black text-sky-600 mb-2 sm:mb-3 lg:mb-4">15+</div>
        <div className="text-xs sm:text-sm lg:text-base font-bold text-gray-800 uppercase tracking-wide leading-tight">Years Experience</div>
      </div>
      <div className="text-center p-4 sm:p-6 lg:p-8 bg-gradient-to-br from-sky-50 to-blue-50 rounded-2xl border border-sky-100 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex-shrink-0 w-64 sm:w-auto">
        <div className="text-4xl sm:text-5xl mb-2">🩺</div>
        <div className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-black text-sky-600 mb-2 sm:mb-3 lg:mb-4">10+</div>
        <div className="text-xs sm:text-sm lg:text-base font-bold text-gray-800 uppercase tracking-wide leading-tight px-2">Years as Doctor of Physical Therapy</div>
      </div>
    </div>
  </div>
</div>

<style jsx>{`
  .scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
`}</style>
          </div>

          {/* Image */}
          <div className="w-full md:w-1/2 flex justify-center md:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-sky-200 rounded-full opacity-20 transform scale-110 blur-lg"></div>
              <img
                src="/Client-Success-Collage.webp"
                alt="Fitness Transformation"
                className="relative z-10 rounded-3xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;